/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forest_ThemeInputs */

const en_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Style`)
};

const ar_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمط الأرض`)
};

const de_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land-Stil`)
};

const es_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de terreno`)
};

const fr_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de sol`)
};

const it_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile del terreno`)
};

const ja_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランドスタイル`)
};

const ko_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`랜드 스타일`)
};

const pt_br_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de terreno`)
};

const ru_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль земли`)
};

const th_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไตล์พื้นดิน`)
};

const tr_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arazi Türü`)
};

const zh_cn_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地皮肤`)
};

const zh_tw_forest_theme = /** @type {(inputs: Forest_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地造型`)
};

/**
* | output |
* | --- |
* | "Land Style" |
*
* @param {Forest_ThemeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const forest_theme = /** @type {((inputs?: Forest_ThemeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forest_ThemeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forest_theme(inputs)
	if (locale === "ar") return ar_forest_theme(inputs)
	if (locale === "de") return de_forest_theme(inputs)
	if (locale === "es") return es_forest_theme(inputs)
	if (locale === "fr") return fr_forest_theme(inputs)
	if (locale === "it") return it_forest_theme(inputs)
	if (locale === "ja") return ja_forest_theme(inputs)
	if (locale === "ko") return ko_forest_theme(inputs)
	if (locale === "pt_br") return pt_br_forest_theme(inputs)
	if (locale === "ru") return ru_forest_theme(inputs)
	if (locale === "th") return th_forest_theme(inputs)
	if (locale === "tr") return tr_forest_theme(inputs)
	if (locale === "zh_cn") return zh_cn_forest_theme(inputs)
	return zh_tw_forest_theme(inputs)
});